import { EffectRef, ElementRef, Signal, effect } from '@angular/core';

export type HostAttrSignalValue = string | number | boolean | null | undefined;

export interface HostAttrSignalBinding {
  attr: string;
  value: Signal<HostAttrSignalValue>;
}

export interface HostAttrSignalSyncConfig {
  bindings: HostAttrSignalBinding[];
  host: ElementRef<HTMLElement>;
  isEnabled?: () => boolean;
}

/**
 * Binds one or more host attributes to signals without relying on Angular host bindings.
 * This is useful for attrs that can go stale on the component host under `OnPush`.
 */
export function bindHostSignalAttrs({ bindings, host, isEnabled = () => true }: HostAttrSignalSyncConfig): EffectRef[] {
  return bindings.map(({ attr, value }) =>
    effect(() => {
      if (!isEnabled()) return;

      const nextValue = value();
      if (nextValue === null || nextValue === undefined) {
        host.nativeElement.removeAttribute(attr);
        return;
      }

      host.nativeElement.setAttribute(attr, String(nextValue));
    })
  );
}
